import PaymentTerms from './PaymentTermsList'

export default PaymentTerms
